import { scaleLinear, scaleOrdinal, scaleTime } from 'd3-scale';
import { schemeAccent } from 'd3-scale-chromatic';
import { select, selectAll, event } from 'd3-selection';
import { max, sum, histogram, extent, min } from 'd3-array';
import { transition } from 'd3-transition';
import { arc, pie, stack, area } from 'd3-shape';
import { axisBottom, axisLeft } from 'd3-axis';
import { interpolate } from 'd3-interpolate';
import { values } from 'd3-collection';
import { timeFormat, timeFormatLocale } from 'd3-time-format';

angular.module('d3', [])
  .factory('d3', () => {
    /* Hack to keep the d3.event mutable, this seems to be a well known
     * bug in Webpack/Babel ES6 transpilation
     * please refer to the links below for better understanding of this issue:
     *
     * https://github.com/d3/d3/issues/2733
     * https://github.com/d3/d3-zoom/issues/32
     * https://github.com/tomwanzek/d3-ng2-service/issues/5
     * http://2ality.com/2015/07/es6-module-exports.html
     * */

    const getEvent = () => event;

    const d3Exports = {
      scaleLinear,
      select,
      selectAll,
      max,
      sum,
      transition,
      arc,
      pie,
      scaleOrdinal,
      scaleTime,
      histogram,
      axisBottom,
      axisLeft,
      interpolate,
      stack,
      area,
      extent,
      min,
      schemeAccent,
      values,
      timeFormat,
      timeFormatLocale,
      getEvent
    };

    return d3Exports;
  });
